<template>
<b-card header="Availables" style="padding: 5px; margin-bottom: 5px; margin-top: 0px;">
  <b-row style=" padding: 0px; margin: 0px;">
    <div class="alert alert-success" v-if="items.length === 0" style="width: 100%;padding: 0px;margin: 0px;">
      <ul class="fa-ul" style="margin-bottom: 0px;">
        <li>
          <i class="fa fa-info-circle fa-li"></i> All keys are assigned.
        </li>
      </ul>
    </div>

    <b-col sm="6" lg="3" v-for="nextItem in items" :key="nextItem.id">
      <lock-card :nextItem=nextItem></lock-card>
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import LockCard from '@/views/base/haus/LockCard'
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
//const API = BASE + '/api/locks/listAvailable'
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

// async function getData () {
//   let param = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     locationId: localStorage.getItem('locationId')
//   }
//   let res = await postdata(API, param)
//   return res.locks
// }

export default {
  name: 'locks-available',
  components: {
    LockCard
  },
  data: () => {
    return {
      items: [],
      allItems: [],
      currentPage: 1,
      continueAdd: true,
      perPage: 20,
      totalRows: 0,
      filter: null,
      selected: [],
      selectAll: false
    }
  },
  mounted () {

    let localLocksList = localStorage.getItem('localLocksList')
    let locationId = localStorage.getItem('locationId')
    localLocksList = JSON.parse(localLocksList)
    
    this.allItems = localLocksList.filter(lock => lock.locationId == locationId).filter(lock => lock.countTotal == 0)
    this.paginate()
    
    //localStorage.setItem('localLocksList', JSON.stringify(localLocksList))
    //  let localListAvailable = localStorage.getItem("localListAvailable");
    
    //   if(localListAvailable === null) {
    //     getData().then(response => {
    //       console.log(JSON.stringify(response))
    //       localStorage.setItem("localListAvailable", JSON.stringify(response))
    //       this.allItems = response
    //       this.paginate()
    //     })
    //   } else {
    //     this.allItems = JSON.parse(localListAvailable)
    //     this.paginate()
    //   }
    
    //this.scroll()
    
  },
  methods: {

    paginate() {
      for (var i in this.allItems) {
        if (i < this.perPage) {
          this.items.push(this.allItems[i])
        }
      }
      this.$data.currentPage = this.$data.currentPage + 1

    },

    // scroll () {
    //   window.onscroll = () => {
    //     let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
    //     if (bottomOfWindow && this.$data.items.length < this.$data.allItems.length) {
    //       var maxId = this.$data.currentPage * this.$data.perPage
    //       var startId = maxId - this.$data.perPage
    //       if (maxId > this.$data.allItems.length) {
    //         maxId = this.$data.allItems.length
    //       }
    //       for (var i = startId; i < maxId; i++) {
    //         this.$data.items.push(this.$data.allItems[i])
    //       }
    //       let afterCount = this.$data.items.length
    //       this.$data.currentPage = this.$data.currentPage + 1
    //     }
    //   }
    // },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    assignToLocation (lockId, idx) {
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        locationId: localStorage.getItem('locationId')
      }
      postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      this.$data.items.splice(idx, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LocksAvailable.vue